import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, TableSortLabel } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import { rpc } from '../utils/RpcUtils';
import * as Constants from '../Constants';
import { getTZDateTimeAsString } from '../utils/DateUtils';
import '../App.css';

const ScheduledEventAdminList = () => {
  const [events, setEvents] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');

  useEffect(() => {
    const fetchEvents = async () => {
      let date = new Date();
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
      const params = {
        shownOn: { $gt: date }
      };
      rpc({
        method: "GetScheduledEvents",
        params,
        setErrorMessage,
        setOpenErrorDialog,
        onSuccess: onSuccess
      });
    };
    fetchEvents();
  }, []);

  const onSuccess = (events) => {
    setEvents(events.filter(e => e._event !== null));
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const sortedEvents = events.slice().sort((a, b) => {
    if (orderBy === 'site') {
      const nameA = a._event._site?.name || '';
      const nameB = b._event._site?.name || '';
      return order === 'asc'
        ? nameA.localeCompare(nameB)
        : nameB.localeCompare(nameA);
    } else if (orderBy === 'shownOn') {
      return order === 'asc'
        ? new Date(a.shownOn) - new Date(b.shownOn)
        : new Date(b.shownOn) - new Date(a.shownOn);
    }
    return 0;
  });


  return (
    <div className="ScheduledEventAdminList">
      <Typography variant="h6" gutterBottom>
        Scheduled Events
      </Typography>
      <TableContainer className="TableContainer" component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={orderBy === 'site'}
                  direction={orderBy === 'site' ? order : 'asc'}
                  onClick={() => handleSort('site')}
                >
                  <b>Site</b>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === 'shownOn'}
                  direction={orderBy === 'shownOn' ? order : 'asc'}
                  onClick={() => handleSort('shownOn')}
                >
                  <b>Shown On</b>
                </TableSortLabel>
              </TableCell>
              <TableCell><b>Event</b></TableCell>
              <TableCell><b>Type</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedEvents.map((event, index) => (
              <TableRow key={index}>
                <TableCell>{event._event._site.name}</TableCell>
                <TableCell>{getTZDateTimeAsString(event.shownOn, 'America/Los_Angeles')}</TableCell>
                <TableCell>{event._event.displayName}</TableCell>
                <TableCell>{Constants.EVENT_NAMES[event._event.type]}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default ScheduledEventAdminList;
